import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import NoIndexHelmet from '../components/NoIndexHelmet';

const PrivateRoute = ({ element, ...rest }) => {
  const { user, loading } = useAuth();
  const location = useLocation();



  // Don't redirect while loading to prevent flashing
  if (loading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #4a1f2a 0%, #6b2937 50%, #8a3543 100%)',
      color: 'white'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid rgba(255, 215, 0, 0.3)',
        borderTop: '3px solid #FFD700',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
    </div>;
  }

  if (!user) {
    // Smart redirect: if current path starts with /mobile, redirect to mobile login
    const isMobileRoute = location.pathname.startsWith('/mobile');
    const redirectPath = isMobileRoute ? '/mobile/login' : '/login';
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return (
    <>
      <NoIndexHelmet />
      {element}
    </>
  );
};

export default PrivateRoute;
